import dayjs from 'dayjs';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';

export class PlatformProduct extends BaseEntityModel {
  id?: number;
  productKey?: ProductKey;
  hubspotLineItemId?: number;
  modelType?: string;
  modelId?: number;
  sourceType?: string;
  sourceId?: number;
  lastBilledAt?: string;
  nextBillingAt?: string;
  checkoutSessionId?: number;
  checkoutSessionItemId?: number;
  subscriptionId?: string;
  cancelAt?: string;
  countryId?: number;

  constructor(model: Partial<PlatformProduct> = {}) {
    super(model);

    this.id = model.id;
    this.productKey = model.productKey;
    this.hubspotLineItemId = model.hubspotLineItemId;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.sourceType = model.sourceType;
    this.sourceId = model.sourceId;
    this.lastBilledAt = model.lastBilledAt;
    this.nextBillingAt = model.nextBillingAt;
    this.checkoutSessionId = model.checkoutSessionId;
    this.checkoutSessionItemId = model.checkoutSessionItemId;
    this.subscriptionId = model.subscriptionId;
    this.cancelAt = model.cancelAt;
    this.countryId = model.countryId;
  }

  get isMonthlyAdvisorProPlan(): boolean {
    return this.productKey === ProductKey.ADVISOR_PRO;
  }

  get isoFormattedNextBillingAt(): string {
    return dayjs(this.nextBillingAt).format(DateFormat.ISO);
  }

  get isoFormattedCancelAt(): string {
    return dayjs(this.cancelAt).format(DateFormat.ISO);
  }
}
